/* eslint-disable @typescript-eslint/naming-convention */
import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { NavigationEnd, Router } from '@angular/router';
import { Platform } from '@ionic/angular';
import { FirebaseAnalytics } from '@capacitor-community/firebase-analytics';
import { FirebaseService } from './firebase.service';
import { environment } from 'src/environments/environment';
// eslint-disable-next-line @typescript-eslint/ban-types
declare let gtag: Function;

@Injectable({
  providedIn: 'root',
})
export class AnalyticsService {
  didInit = false;

  constructor(
    private router: Router,
    private firebaseService: FirebaseService,
    private platform: Platform,
    private titleService: Title
  ) {}

  async init(analyticsLink: string) {
    if (analyticsLink) {
      const gaScript = document.createElement('script');
      gaScript.setAttribute('async', 'true');
      gaScript.setAttribute('src', analyticsLink);

      const gaScript2 = document.createElement('script');
      // eslint-disable-next-line max-len
      gaScript2.innerText = `window.dataLayer = window.dataLayer || [];function gtag(){dataLayer.push(arguments);}gtag(\'js\', new Date());gtag(\'config\', \'${
        analyticsLink.split('?id=')[1]
      }\');`;

      document.documentElement.firstChild.appendChild(gaScript);
      document.documentElement.firstChild.appendChild(gaScript2);

      this.router.events.subscribe(async (event) => {
        if (event instanceof NavigationEnd) {
          this.eventEmitter(event.url, 'route', 'navigation', 'navigation');

          if (!this.firebaseService.FIREBASECONFIG) {
            this.firebaseService.getFirebaseConfig(environment.hotelId);
          }

          this.setTitle();
        }
      });

      this.didInit = true;
    }
  }
  setTitle() {
    if (this.platform && this.platform.is('ios')) {
      this.setScreenViewIos();
    } else {
      this.setScreenView();
    }
  }
  eventEmitter(
    eventName: string,
    eventCategory: string,
    eventAction: string,
    eventLabel: string = null,
    eventValue: number = null
  ) {
    try {
      if (gtag && this.didInit) {
        gtag('event', eventName, {
          category: eventCategory,
          eventLabel,
          eventAction,
          eventValue,
        });
      }
    } catch {}
  }

  async setScreenView() {
    gtag('event', 'screen_view', {
      app_name: this.titleService.getTitle(),
    });
  }

  async setScreenViewIos() {

    FirebaseAnalytics.logEvent({
      name: 'screen_view',
      params: { app_name: this.titleService.getTitle() },
    });

    FirebaseAnalytics.logEvent({
      name: 'screen_view',
      params: { screen_name: this.titleService.getTitle() },
    });

    FirebaseAnalytics.setScreenName({
      screenName: this.titleService.getTitle(),
      nameOverride: this.titleService.getTitle(),
    }).catch((error) => console.log(error));
  }
}
